import { useState } from "react";
import { Paperclip, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { EventAttachmentPreview } from "../employees/EventAttachmentPreview";
import { getRecapFile, recapFileUrl } from "../../services/recaps";

export const RecapFiles = ({ files, recapId }) => {
  const [preview, setPreview] = useState(null), [busy, setBusy] = useState(null);
  const download = async item => {
    setBusy(item.id);
    try {
      const { data } = await getRecapFile(recapId, item.id);
      const url = URL.createObjectURL(data), a = document.createElement("a");
      a.href = url; a.download = item.filename; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { toast.error("Téléchargement impossible ou accès non autorisé."); }
    finally { setBusy(null); }
  };
  return <>
    <ul className="space-y-2 mt-3">{files.map(item => <li key={item.id} className="flex items-center gap-2 min-w-0 border-b border-slate-100 pb-2" data-testid={`recap-file-${item.id}`}>
      <Paperclip size={15} className="shrink-0 text-[#26788A]" />
      <button className="text-left flex-1 min-w-0 text-sm text-[#26788A] break-words [overflow-wrap:anywhere] hover:underline min-h-11" data-testid={`recap-file-open-${item.id}`} onClick={() => /^(image|audio|video)\//.test(item.content_type) || item.content_type === "application/pdf" ? setPreview(item) : download(item)}>{item.filename}</button>
      <button aria-label={`Télécharger ${item.filename}`} className="p-3 text-slate-500 hover:text-[#26788A] transition-colors" disabled={!!busy} data-testid={`recap-file-download-${item.id}`} onClick={() => download(item)}>{busy === item.id ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}</button>
    </li>)}</ul>
    {preview && <EventAttachmentPreview attachment={preview} eventId={recapId} getContent={getRecapFile} getContentUrl={recapFileUrl} onClose={() => setPreview(null)} />}
  </>;
};